export class Clue {
    word: string;
    metrics: number[];
    explanations: string[];
    order: number;

    constructor(rw: any, codes: string[] | null = null) {
        this.word = rw.word;
        let lm = codes ? codes[0] : 0;
        let rm = codes ? codes[1] : 1;
        this.metrics = [rw.metrics[lm], rw.metrics[rm]];
        this.explanations = rw.explanations;
        this.order = rw.order || 0;
    }

    toPojo() {
        return {
            word: this.word,
            metrics: this.metrics,
            explanations: this.explanations
        };
    }
}